export const toKebabCase = (text: string): string => {
  if (typeof text === 'string') {
    return text
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/[\s_]+/g, '-')
      .toLowerCase()
  } else {
    return ''
  }
}

export const toCamelCase = (value: string): string =>
  value.toLowerCase().replace(/[-_.\s]+([a-z0-9])/g, (_, c: string) => c.toUpperCase())

export const toNumberArray = (value: string): number[] =>
  value ? value.split(',').map((s) => parseInt(s)) : []

export const toBool = (value?: string): boolean => {
  if (value === '1') {
    return true
  } else if (value === '0') {
    return false
  } else {
    return false
  }
}

export const toFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'

  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  const value = bytes / Math.pow(k, i)

  return `${value.toFixed(1)} ${sizes[i]}`
}
